import request from '@/utils/request';

export async function queryStockForCrossAllocate(payload) {
  return request(`/iwms-wms/wms/twoStepCrossAllocate/queryStockForCrossAllocate`, {
    method: 'POST',
    body: payload
  });
}

export async function oneKeyCrossAllocate(payload) {
  return request(`/iwms-wms/wms/twoStepCrossAllocate/oneKeyCrossAllocate?dcUuid=${payload.dcUuid}&waveBillNumber=${payload.waveBillNumber ? payload.waveBillNumber : ''}`, {
    method: 'POST',
    body: payload
  });
}

